import React from 'react';
import recordEvent from 'platform/monitoring/record-event';

export default function TravelClaimsSection() {
  const recordLinkClick = () =>
    recordEvent({
      event: 'nav-link-click',
      'link-label': 'Review and file travel reimbursement claims',
      'link-destination': '/my-health/travel-pay/claims',
    });

  return (
    <div className="vads-u-margin-y--4">
      <h2 id="your-travel-reimbursement-claims">
        Your travel reimbursement claims
      </h2>
      <va-link
        active
        disable-analytics
        href="/my-health/travel-pay/claims"
        text="Review and file travel reimbursement claims"
        onClick={recordLinkClick}
      />
      <p className="vads-u-margin-y--0p5">
        File new claims for travel pay and review the status of all your travel
        reimbursement claims.
      </p>
    </div>
  );
}
